module.exports = __webpack_public_path__ + "img/tina_d.da1cf473.png";